import { useState, useEffect } from "react";
import "./style.css";
import "react-toastify/dist/ReactToastify.css";

import { MdKeyboardArrowUp } from "react-icons/md";

import Navbar from "./components/navbar";
import Carousel from "./components/carousel";
import Services from "./components/services";
import About from "./components/about";
import Contact from "./components/contact";
import Footer from "./components/footer";
import { ToastContainer } from "react-toastify";

function App() {
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      // Change 100 to any threshold you'd like
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="App">
      <Navbar scrolled={scrolled} />
      <Carousel />
      <Services />
      <About />
      <Contact />
      <Footer />
      <a
        href="#top"
        className={scrolled ? "scrolltop" : "scrolltop hidescrolltop"}
      >
        <MdKeyboardArrowUp />
        TO TOP
      </a>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
